<!-- ----------------------------------------------- -->
<template>
  <v-card
    id="vc-dialog"
    class="com-mb-dialog normal v-card v-sheet theme--light"
    :class="[
      {
        small: editLocationMode === 1 || editTmMode === 1 || editTmMode === 2,
      },
      { large: isFull },
      { normal: !isFull },
    ]"
  >
    <v-row class="com-mb-dialog-header">
      <span class="com-mb-dialog-title rw-title">{{ text.title }}</span>
      <v-spacer></v-spacer>
      <v-btn v-show="!isFull" small icon color="white" @click="expansionWindow">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-btn v-show="isFull" small icon color="white" @click="reductionWindow">
        <v-icon>fullscreen_exit</v-icon>
      </v-btn>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-row class="vc-tab pa-1 ml-2">
      <v-btn
        class="vc-btn-item mr-2 pa-1"
        :class="{ 'com-btn-on': tabIndex === 0 }"
        @click="tabIndex = 0"
        v-if="!isReduction"
      >
        <v-icon light>where_to_vote</v-icon>
        {{ text.pointRegistration }}
      </v-btn>
      <v-btn
        class="vc-btn-item pa-1"
        :class="{ 'com-btn-on': tabIndex === 1 }"
        @click="tabIndex = 1"
      >
        <v-icon light>settings_applications</v-icon>
        {{ text.initialDisplay }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="content === 'VcCustom'"
        class="vc-btn-item pa-1 mr-2"
        @click="clickInitial"
      >
        {{ text.initialSetting }}
      </v-btn>
      <v-btn
        v-if="content === 'VcCustom'"
        class="vc-btn-item pa-1 mr-2"
        @click="clickReturn"
      >
        <v-icon left>keyboard_arrow_left</v-icon>
        {{ text.rtn }}
      </v-btn>
    </v-row>
    <!-- 地点登録 -->
    <v-col
      v-if="content === 'VcPoint'"
      class="com-mb-dialog-contents vc-contents"
    >
      <v-col class="com-mb-dialog-frame pt-0">
        <vc-point></vc-point>
        <vc-tm-list></vc-tm-list>
      </v-col>
    </v-col>
    <!-- 初期表示 -->
    <v-col
      v-if="content === 'VcDefault'"
      class="com-mb-dialog-contents vc-contents"
    >
      <v-col class="com-mb-dialog-frame pt-0">
        <vc-default></vc-default>
      </v-col>
    </v-col>
    <!-- カスタマイズ設定 -->
    <v-col
      v-if="content === 'VcCustom'"
      class="com-mb-dialog-contents vc-contents"
    >
      <v-col class="com-mb-dialog-frame pt-0">
        <vc-custom></vc-custom>
      </v-col>
    </v-col>
    <!-- 地点登録ダイアログ -->
    <v-col
      v-if="
        editLocationMode === 1 ||
        editLocationMode === 2 ||
        editTmMode === 1 ||
        editTmMode === 2
      "
      class="vc-dialog-content"
    >
      <v-card class="ma-4 vc-dialog-card">
        <div class="vc-dialog-header pl-4">
          <span class="vc-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div class="vc-dialog-box pl-4 pr-2 my-2">
          <v-label v-if="editLocationMode === 1">{{
            text.selectPointMsg
          }}</v-label>
          <div
            v-if="editLocationMode === 2 && towns && isRegistTown()"
            class="vc-radio-box"
          >
            <v-label>{{ text.confirmPointMsg }}</v-label>
            <v-radio-group v-model="twnCd" class="ml-2">
              <v-radio
                v-for="town in towns"
                :key="town.twnCd"
                :label="town.prefNm + town.twnNm"
                :value="town.twnCd"
              ></v-radio>
              <v-radio
                v-for="townAdd in townsAdd"
                :key="townAdd.twnCd"
                :label="townAdd.prefNm + townAdd.twnNm"
                :value="townAdd.twnCd"
              ></v-radio>
            </v-radio-group>
          </div>
          <div v-if="editLocationMode === 2 && towns && !isRegistTown()">
            <v-label>{{ text.registErrMsg }}</v-label>
          </div>
          <v-label v-if="editTmMode === 1">{{ text.selectObMsg }}</v-label>
          <v-label v-if="editTmMode === 2">{{ text.confirmObMsg }}</v-label>
        </div>
        <div
          v-if="registCurrentLocationErrorFlag && editLocationMode === 1"
          class="get-location-error-message pl-4"
        >
          {{ messageConfig.currentLocationError }}
        </div>
        <div class="vc-dialog-footer pb-1 pr-4 mb-0">
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              (editLocationMode === 2 && towns && isRegistTown()) ||
              editTmMode === 2
            "
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="regist"
          >
            <v-icon left>add_box</v-icon>
            {{ text.register }}
          </v-btn>
          <v-btn
            v-if="editLocationMode === 1"
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="registCurrentLocation()"
          >
            <v-icon left>my_location</v-icon>
            {{ text.currentLocation }}
          </v-btn>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="cancel"
          >
            <v-icon left>clear</v-icon>
            {{ text.cancel }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
    <!-- 確認ダイアログ -->
    <v-col v-if="riskFlg === 1" class="vc-dialog-content">
      <v-card class="ma-4 vc-dialog-card">
        <div class="vc-dialog-header pl-4">
          <span class="vc-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div
          v-if="continuation === 2"
          class="vc-dialog-box vc-dialog-box-confirm pl-4 pr-2 my-2"
        >
          {{ text.continuationMsg1 }}
          <br />
          {{ text.continuationMsg2 }}
        </div>
        <div v-else class="vc-dialog-box vc-dialog-box-confirm pl-4 pr-2 my-2">
          {{ text.confirmInfoMsg1 }}
          <br />
          {{ text.confirmInfoMsg2 }}
        </div>
        <div class="vc-dialog-box pb-1 pr-4 mb-0">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="confirm"
          >
            <v-icon left>add_box</v-icon>
            {{ text.confirm }}
          </v-btn>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="cancelConfirm"
          >
            <v-icon left>clear</v-icon>
            {{ text.cancel }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
    <!-- 削除確認ダイアログ -->
    <v-col v-if="deleteFlg === 1" class="vc-dialog-content">
      <v-card class="ma-4 vc-dialog-card">
        <div class="vc-dialog-header pl-4">
          <span class="vc-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div class="vc-dialog-box vc-dialog-box-confirm pl-4 pr-2 my-2">
          {{ text.deleteInfoMsg }}
        </div>
        <div class="vc-dialog-box pb-1 pr-4 mb-0">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="confirmDelete"
          >
            <v-icon left>cancel</v-icon>
            {{ text.delete }}
          </v-btn>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="cancelDelete"
          >
            <v-icon left>clear</v-icon>
            {{ text.cancel }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
    <!-- 時間がかかる旨の表示ダイアログ -->
    <v-col v-if="isInfo" class="vc-dialog-content">
      <v-card class="ma-4 vc-dialog-card">
        <div class="vc-dialog-header pl-4">
          <span class="vc-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div class="vc-dialog-box vc-dialog-box-confirm pl-4 pr-2 my-2">
          {{ text.registInfoMsg1 }}
          <br />
          {{ text.registInfoMsg2 }}
        </div>
        <div class="vc-dialog-box pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="isInfo = false"
          >
            <v-icon left>add_box</v-icon>
            {{ text.confirmInfo }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
    <!-- アイコン設定ダイアログ -->
    <v-col v-if="iconEditFlg" class="vc-dialog-content">
      <v-card class="ma-4 vc-dialog-card">
        <div class="vc-dialog-header pl-4">
          <span class="vc-dialog-title">{{ text.iconEdit }}</span>
        </div>
        <!-- 色選択 -->
        <div class="pl-2 mt-1">色</div>
        <div class="vc-dialog-box-color pl-1">
          <div
            v-for="(color, idx) in colors"
            :key="'color_' + idx"
            class="vc-box-color"
          >
            <v-btn icon @click="colorIdx = idx">
              <v-icon
                large
                :color="color.color"
                :class="{
                  'vc-icon-btn-border': colorIdx === idx,
                  'vc-icon-btn': iconIdx !== idx,
                }"
              >
                stop
              </v-icon>
            </v-btn>
          </div>
        </div>
        <!-- 大・中・小 -->
        <div class="pl-2">サイズ</div>
        <div class="vc-dialog-box-size pb-2 pl-4">
          <div class="vc-box-size">
            <v-img
              class="vc-icon-btn"
              :class="{
                'com-btn-on': sizeIdx === 0,
              }"
              :src="getIconUrl(0)"
              max-width="46px"
              @click="sizeIdx = 0"
            ></v-img>
          </div>
          <div class="vc-box-size ml-2">
            <v-img
              class="vc-icon-btn"
              :class="{
                'com-btn-on': sizeIdx === 1,
              }"
              :src="getIconUrl(0)"
              max-width="38px"
              @click="sizeIdx = 1"
            ></v-img>
          </div>
          <div class="vc-box-size ml-2">
            <v-img
              class="vc-icon-btn"
              :class="{
                'com-btn-on': sizeIdx === 2,
              }"
              :src="getIconUrl(0)"
              max-width="30px"
              @click="sizeIdx = 2"
            ></v-img>
          </div>
        </div>
        <!-- アイコン -->
        <div class="pl-2">アイコン</div>
        <div class="vc-dialog-box-icon pl-3 py-2">
          <div
            v-for="(icon, idx) in icons"
            :key="'icon_' + icon"
            class="vc-box-icon pr-2"
          >
            <v-img
              :class="{
                'vc-icon-btn-border': iconIdx === idx,
                'vc-icon-btn': iconIdx !== idx,
              }"
              :src="getIconUrl(idx)"
              max-width="36px"
              @click="iconIdx = idx"
            ></v-img>
          </div>
        </div>
        <!-- ボタン -->
        <div class="vc-dialog-box-btn pr-4">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="iconSelect"
          >
            {{ text.select }}
          </v-btn>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="iconCancel"
          >
            {{ text.cancel }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
    <!-- プログレスダイアログ -->
    <v-col
      v-if="
        riskFlg === 2 &&
        this.editFlag !== 0 &&
        this.editLocationMode !== 1 &&
        !isInfo
      "
      class="vc-dialog-content"
    >
      <v-card class="ma-4 vc-dialog-card">
        <div class="vc-dialog-header pl-4">
          <span class="vc-dialog-title">{{ text.progressTitle }}</span>
        </div>
        <div class="vc-dialog-box vc-dialog-box-progress pl-4 mt-2">
          <span v-if="!registPointErrMsg">{{ text.progressMsg }}</span>
          <span v-else>{{ registPointErrMsg }}</span>
          <div class="vc-td-item-loading">
            <v-progress-linear
              :value="progressValue"
              height="25"
              color="orange lighten-2"
              class="px-4"
            >
              {{ progressValue }}%</v-progress-linear
            >
          </div>
          <div class="vc-td-item-cancel mt-2">
            <v-spacer></v-spacer>
            <v-btn
              class="mr-4"
              small
              outlined
              color="success"
              @click="registCancel()"
              ><v-icon left>clear</v-icon>{{ text.cancel }}</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-col>

    <!-- リスク判定時のメッセージ表示ダイアログ -->
    <v-col v-if="!isInfo && registPointMsg" class="vc-dialog-content">
      <v-card class="ma-4 vc-dialog-card">
        <div class="vc-dialog-header pl-4">
          <span class="vc-dialog-title">{{ text.progressTitle }}</span>
        </div>
        <div class="vc-dialog-box vc-dialog-box-confirm pl-4 pr-2 my-2">
          {{ registPointMsg }}
        </div>
        <div class="vc-dialog-box pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="clearMsg"
          >
            <v-icon left>add_box</v-icon>
            {{ text.confirmInfo }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 河川予警報一覧ダイアログ
 * Viewconfig.vue
 * @author LIS
 */
import mixin from "./../../../lib/mixin.js";
import VcPoint from "../../../components/mb/VcPoint.vue";
import VcTmList from "../../../components/mb/VcTmList.vue";
import VcDefault from "../../../components/mb/VcDefault.vue";
import VcCustom from "../../../components/mb/VcCustom.vue";
import WebStorage from "./../../../lib/webStorage.js";
import mapUtil from "./../../../lib/mapUtil.js";
import geodesic from "./../../../lib/geodesic.js";
import PageLog from "./../../../lib/pageLog.js";

export default {
  /** タグ名 */
  name: "mb-vc",
  mixins: [mixin],
  components: { VcPoint, VcTmList, VcDefault, VcCustom },
  data() {
    return {
      isFull: false,
      twnCd: "",
      townsAdd: [],
      continuation: 0,
      tabIndex: 0,
      isInfo: false,
      colorIdx: 5,
      sizeIdx: 1,
      iconIdx: 3,
      iconUrl: "/kawabou/img/map_icons/",
      colors: [
        {
          name: "fuchsia",
          color: "#ff00ff",
        },
        {
          name: "red",
          color: "#ff0000",
        },
        {
          name: "lime",
          color: "#00ff00",
        },
        {
          name: "green",
          color: "#008000",
        },
        {
          name: "teal",
          color: "#008080",
        },
        {
          name: "navy",
          color: "#000080",
        },
        // {
        //   name: "gray",
        //   color: "#808080",
        // },
        {
          name: "black",
          color: "#000000",
        },
      ],
      icons: [
        "rp_base",
        "rp_home",
        // "rp_maps_home_work",
        "rp_push_pin",
        // "rp_museum",
        // "rp_apartment",
      ],
      text: {
        title: "表示設定",
        pointRegistration: "地点登録",
        iconEdit: "アイコン選択",
        initialDisplay: "初期表示",
        initialSetting: "最初の設定に戻す",
        rtn: "戻る",
        sizeL: "大",
        sizeM: "中",
        sizeS: "小",
        selectPointMsg: "地図上で、地点登録したい位置を選択して下さい。",
        confirmPointMsg: "選択された地点を登録します。よろしいですか？",
        registErrMsg: "選択された地点は登録可能な市町村が存在しません。",
        selectObMsg: "地図上で、登録したい観測所を選択して下さい。",
        confirmObMsg: "選択された観測所を登録します。よろしいですか？",
        confirmInfoMsg1: "登録した地点のリスク判定を行います。",
        confirmInfoMsg2: "リスク判定は、最大５分程度かかる場合があります。",
        continuationMsg1: "地点を登録しました。",
        continuationMsg2:
          "続けて、登録した地点のリスク判定を行いますか？（最大5分程度かかる場合があります。）",
        registInfoMsg1:
          "リスク判定は、周辺の川が氾濫した場合の浸水想定を計算します。",
        registInfoMsg2:
          "この画面を閉じなければ、他画面を操作していてもリスク判定を進めることができます。",
        deleteInfoMsg: "登録地点を削除しますか？",
        progressTitle: "リスク判定",
        progressMsg: "判定中...",
        pointName: "地点",
        register: "登録",
        confirmInfo: "確認",
        confirm: "判定実行",
        delete: "削除",
        cancel: "キャンセル",
        select: "選択",
        currentLocation: "現在位置登録",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[Viewconfig] mounted()");
    if (
      this.content !== "VcPoint" ||
      this.content !== "VcDefault" ||
      this.content !== "VcCustom"
    ) {
      if (this.isReduction) {
        // 簡易版では地点登録を表示しない
        this.tabIndex = 1;
        this.$store.commit("app/setContent", "VcDefault");
      } else {
        this.$store.commit("app/setContent", "VcPoint");
      }
    }
    // 選択値クリア
    this.$store.commit("viewConfig/setSelectedPoint", "");
    // パラメータによって初期表示するタブを変更する
    let setQuery = Object.assign({}, this.$route.query);
    if (this.isReduction) {
      // 簡易版では地点登録を表示しない
      setQuery.type = "default";
      this.tabIndex = 1;
    } else {
      if (setQuery.type == "default") {
        this.tabIndex = 1;
      } else {
        this.tabIndex = 0;
        setQuery.type = "point";
      }
    }
    // urlを書き換える
    this.$router.replace({
      path: this.$route.path,
      query: setQuery,
    });
  },
  computed: {
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /** タブ選択値 */
    selectedIndex: {
      get() {
        return this.tabIndex;
      },
    },
    /** 登録地編集モード */
    editLocationMode: {
      get() {
        return this.$store.state.map.editLocationMode;
      },
    },
    /** 登録地点選択座標 */
    editLocation: {
      get() {
        return this.$store.state.map.editLocation;
      },
    },
    /** 周辺観測所編集モード */
    editTmMode: {
      get() {
        return this.$store.state.map.editTmMode;
      },
    },
    /** 周辺観測所 */
    editTm: {
      get() {
        return this.$store.state.map.editTm;
      },
    },
    /** 地点登録 選択テレメータ情報 */
    tmSelectedPointData: {
      get() {
        return this.$store.state.Telemeter.tmSelectedPointData;
      },
    },
    /** 地点登録 選択危機管理型水位計情報 */
    swSelectedPointData: {
      get() {
        return this.$store.state.Swin.swSelectedPointData;
      },
    },
    /** 地点登録 選択危機カメラ情報 */
    swSelectedPointCctvData: {
      get() {
        return this.$store.state.Swin.swSelectedPointCctvData;
      },
    },
    /** 地点登録 選択簡易カメラ情報 */
    swSelectedPointScamData: {
      get() {
        return this.$store.state.Swin.swSelectedPointScamData;
      },
    },
    /** 範囲内の市町村 */
    towns: {
      get() {
        return this.$store.state.viewConfig.towns;
      },
    },
    /** 簡易版判定  */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
    /** メッセージ情報 */
    messageConfig: {
      get() {
        return this.$store.state.app.config.messageConfig;
      },
    },
    /** 現在位置登録エラーフラグ */
    registCurrentLocationErrorFlag: {
      get() {
        return this.$store.state.map.registCurrentLocationErrorFlag;
      },
    },
    /** 現在位置登録フラグ */
    registCurrentLocationFlag: {
      get() {
        return this.$store.state.map.registCurrentLocationFlag;
      },
    },
    /** リスク収集フラグ */
    riskFlg: {
      get() {
        return this.$store.state.viewConfig.riskFlg;
      },
    },
    /** 削除フラグ */
    deleteFlg: {
      get() {
        return this.$store.state.viewConfig.deleteFlg;
      },
    },
    /** アイコン設定中フラグ */
    iconEditFlg: {
      get() {
        return this.$store.state.viewConfig.iconEditFlg;
      },
    },
    /** 登録中フラグ */
    editFlag: {
      get() {
        return this.$store.state.map.editFlag;
      },
    },
    /** プログレスの値 */
    progressValue: {
      get() {
        let val = (this.$store.state.Telemeter.registPointState / 4) * 100;
        return val;
      },
    },
    /** 地点登録エラーメッセージ */
    registPointErrMsg: {
      get() {
        return this.$store.state.Telemeter.registPointErrMsg;
      },
    },
    /** 地点登録メッセージ */
    registPointMsg: {
      get() {
        return this.$store.state.Telemeter.registPointMsg;
      },
    },
  },

  /** メソッド */
  methods: {
    /** 画面拡大 */
    expansionWindow() {
      this.$log.debug("[Viewconfig] expansionWindow()");
      this.isFull = true;
    },
    /** 画面縮小 */
    reductionWindow() {
      this.$log.debug("[Viewconfig] reductionWindow()");
      this.isFull = false;
    },
    /** 画面を閉じる */
    closeDlg() {
      this.$log.debug("[Viewconfig] closeDlg()");
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    },
    /** 戻るボタンクリック */
    clickReturn() {
      this.$log.debug("[VcCustom] clickReturn()");
      this.$store.commit("app/setContent", "VcDefault");
    },
    /** キャンセル */
    cancel() {
      this.$log.debug("[Viewconfig] cancel()");
      this.$store.commit("map/setEditLocationMode", 0);
      this.$store.commit("map/setEditTmMode", 0);
      this.$store.commit("map/setEditFlag", 0);
    },
    /** 登録 */
    regist() {
      this.$log.debug("[Viewconfig] regist()");
      if (this.editLocationMode === 2) {
        this.$log.debug("[Viewconfig] regist editLocationMode == 2");
        // ボタンを登録中で表示
        this.$store.commit("map/setEditFlag", 1);
        // 地点選択時
        var points = [
          {
            lat: this.$store.state.map.editLocation.latlng[0],
            lng: this.$store.state.map.editLocation.latlng[1],
          },
        ];

        let targetTwn = {};
        for (let town of this.towns) {
          if (town.twnCd === this.twnCd) {
            targetTwn = town;
            targetTwn.townNm = targetTwn.twnNm;
            targetTwn.townCd = targetTwn.twnCd;
            break;
          }
        }
        for (let townAdd of this.townsAdd) {
          if (townAdd.twnCd === this.twnCd) {
            targetTwn = townAdd;
            targetTwn.townNm = targetTwn.twnNm;
            targetTwn.townCd = targetTwn.twnCd;
            break;
          }
        }

        var riverInfo = { sys: "ph2" };
        geodesic.getPointEl(points, riverInfo, (self) => {
          var centerHeight = null;
          if (self.pointsData != null && self.pointsData.length > 0) {
            centerHeight = Math.round(self.pointsData[0].h * 100) / 100;
          }
          let pointInfo = {
            pointIndex: this.$store.state.viewConfig.selectedPoint,
            name: this.$store.state.viewConfig.selectedPointName,
            center: this.$store.state.map.editLocation.latlng,
            centerHeight: centerHeight,
            twnCd: targetTwn.townCd,
            prefCd: targetTwn.prefCd,
            address: targetTwn.prefNm + targetTwn.townNm,
            risk: false,
            luDatas: [],
            tmDatas: {
              tmPoint: [],
              swPoint: [],
              scamPoint: [],
            },
            bpDatas: [],
            zoom: this.$store.state.map.editLocation.zoom,
          };
          this.$store.commit("Telemeter/setTmPointDatas", pointInfo);
          this.$store.commit("map/setEditLocationMode", 0);
        });

        // 継続チェック判定を設定
        this.continuation = 1;
      }
      if (this.editTmMode === 2) {
        this.$log.debug("[Viewconfig] regist editTmMode == 2");
        // 観測所選択時
        let point;
        switch (this.$store.state.viewConfig.selectedPoint) {
          case 0:
            point = WebStorage.getPoint1Info();
            break;
          case 1:
            point = WebStorage.getPoint2Info();
            break;
          case 2:
            point = WebStorage.getPoint3Info();
            break;
          case 3:
            point = WebStorage.getPoint4Info();
            break;
          case 4:
            point = WebStorage.getPoint5Info();
            break;
        }
        // 選択観測所がwebストレージに登録済みかチェック
        let isNew = true;
        if (this.editTm.itmkndCd === 100 || this.editTm.itmkndCd === 200) {
          // 簡易カメラの場合
          let scamId = this.editTm.scamId;
          if (point.tmDatas.scamPoint != null) {
            for (
              var idxScam = 0;
              idxScam < point.tmDatas.scamPoint.length;
              idxScam++
            ) {
              if (point.tmDatas.scamPoint[idxScam].scamId == scamId) {
                isNew = false;
                break;
              }
            }
          }

          if (isNew) {
            this.$log.debug("[Viewconfig] regist editTm.scamId isNew == true");
            var distanceScam = geodesic.getDistance(
              [point.center[0], point.center[1]],
              [this.editTm.lat, this.editTm.lon]
            );
            distanceScam = Math.round(distanceScam * 10) / 10;

            // 地点登録の周辺簡易カメラの情報を取得
            this.$store.dispatch("Swin/getSwSelectedPointScamData", {
              scamId: scamId,
              lat: this.editTm.lat,
              lon: this.editTm.lon,
              distance: distanceScam,
            });
          } else {
            this.$log.debug("[Viewconfig] regist editTm.scamId isNew == false");
            // 登録済みの場合はモードのみ更新
            this.$store.commit("map/setEditTmMode", 0);
          }
        } else if (this.editTm.itmkndCd === 300) {
          // 危機管理型水位計の場合
          let swobsCd = this.editTm.swobsCd;
          for (var idxSw = 0; idxSw < point.tmDatas.swPoint.length; idxSw++) {
            if (point.tmDatas.swPoint[idxSw].swobsCd == swobsCd) {
              isNew = false;
              break;
            }
          }

          if (isNew) {
            this.$log.debug("[Viewconfig] regist editTm.swobsCd isNew == true");
            var distanceSw = geodesic.getDistance(
              [point.center[0], point.center[1]],
              [this.editTm.lat, this.editTm.lon]
            );
            distanceSw = Math.round(distanceSw * 10) / 10;

            // 地点登録の周辺簡易カメラの情報を取得
            this.$store.dispatch("Swin/getSwSelectedPointData", {
              swobsCd: swobsCd,
              distance: distanceSw,
            });
          } else {
            this.$log.debug(
              "[Viewconfig] regist editTm.swobsCd isNew == false"
            );
            // 登録済みの場合はモードのみ更新
            this.$store.commit("map/setEditTmMode", 0);
          }
        } else {
          this.$log.debug("[Viewconfig] regist editTm.obsFcd");
          // テレメータの場合
          let ofcCd = Number(this.editTm.obsFcd.substring(0, 5));
          let itmkndCd = Number(this.editTm.obsFcd.substring(5, 8));
          let obsCd = Number(this.editTm.obsFcd.substring(8));

          for (var idxTm = 0; idxTm < point.tmDatas.tmPoint.length; idxTm++) {
            if (
              point.tmDatas.tmPoint[idxTm].ofcCd == ofcCd &&
              point.tmDatas.tmPoint[idxTm].itmkndCd == itmkndCd &&
              point.tmDatas.tmPoint[idxTm].obsCd == obsCd
            ) {
              isNew = false;
              break;
            }
          }
          // 選択観測所が未登録の場合はwebストレージに追加
          if (isNew) {
            this.$log.debug("[Viewconfig] regist editTm.obsFcd isNew == true");
            // 地点からの距離を算出
            var distanceTm = geodesic.getDistance(
              [point.center[0], point.center[1]],
              [this.editTm.lat, this.editTm.lon]
            );
            distanceTm = Math.round(distanceTm * 10) / 10;

            // 地点登録の周辺観測所の情報を取得
            this.$store.dispatch("Telemeter/getTmSelectedPointData", {
              ofcCd: ofcCd,
              itmkndCd: itmkndCd,
              obsCd: obsCd,
              lat: this.editTm.lat,
              lon: this.editTm.lon,
              distance: distanceTm,
            });
          } else {
            this.$log.debug("[Viewconfig] regist editTm.obsFcd isNew == false");
            // 登録済みの場合はモードのみ更新
            this.$store.commit("map/setEditTmMode", 0);
          }
        }
      }
    },
    /** 確認 */
    confirm() {
      this.$log.debug("[Viewconfig] confirm()");

      let index = this.$store.state.viewConfig.selectedPoint;
      let point;

      // webストレージから表示情報を取得
      if (index === 0) {
        point = WebStorage.getPoint1Info();
      } else if (index === 1) {
        point = WebStorage.getPoint2Info();
      } else if (index === 2) {
        point = WebStorage.getPoint3Info();
      } else if (index === 3) {
        point = WebStorage.getPoint4Info();
      } else if (index === 4) {
        point = WebStorage.getPoint5Info();
      }

      let centerTwn = {
        townCd: point.twnCd,
        prefCd: point.prefCd,
        address: point.address,
      };
      let maxmin = this.getTownNameRange(point.center);

      // リスク判定を行う
      this.$store.dispatch("Telemeter/getTmDatasByPoint", {
        pointIndex: index,
        name: point.name,
        center: point.center,
        centerTwn: centerTwn,
        centerHeight: point.centerHeight,
        minLatLon: maxmin.minCoord,
        maxLatLon: maxmin.maxCoord,
        zoom: point.zoom,
        token: this.$store.state.app.token,
        iconImg: point.iconImg,
        iconSize: point.iconSize,
      });

      this.$store.commit("map/setEditFlag", 1);
      this.$store.commit("viewConfig/setRiskFlg", 2);
      this.isInfo = true;
      // 確認状態のクリア
      this.continuation = 0;
    },
    /** キャンセル */
    cancelConfirm() {
      this.$log.debug("[Viewconfig] cancelConfirm()");
      this.continuation = 0;
      this.$store.commit("viewConfig/setRiskFlg", 0);
    },
    /** 削除確認確認 */
    confirmDelete() {
      this.$log.debug("[Viewconfig] confirmDelete()");

      let index = this.$store.state.viewConfig.selectedPoint;
      let point = "";
      let defaultInfo = WebStorage.getDefaultInfo();
      switch (index) {
        case 0:
          this.$log.debug("[Viewconfig] confirmDelete index == 0");
          WebStorage.setPoint1Info(point);
          if (defaultInfo.point1) {
            defaultInfo.point1 = false;
          }
          break;
        case 1:
          this.$log.debug("[Viewconfig] confirmDelete index == 1");
          WebStorage.setPoint2Info(point);
          if (defaultInfo.point2) {
            defaultInfo.point2 = false;
          }
          break;
        case 2:
          this.$log.debug("[Viewconfig] confirmDelete index == 2");
          WebStorage.setPoint3Info(point);
          if (defaultInfo.point3) {
            defaultInfo.point3 = false;
          }
          break;
        case 3:
          this.$log.debug("[Viewconfig] confirmDelete index == 3");
          WebStorage.setPoint4Info(point);
          if (defaultInfo.point4) {
            defaultInfo.point4 = false;
          }
          break;
        case 4:
          this.$log.debug("[Viewconfig] confirmDelete index == 4");
          WebStorage.setPoint5Info(point);
          if (defaultInfo.point5) {
            defaultInfo.point5 = false;
          }
          break;
      }
      defaultInfo.pointDefault = true;
      WebStorage.setDefaultInfo(defaultInfo);

      // 地点の削除
      this.$store.dispatch("Telemeter/deletePoint", {
        pointNo: index + 1,
        token: this.$store.state.app.token,
      });

      // 削除フラグをクリア
      this.$store.commit("viewConfig/setDeleteFlg", 0);
      // 選択値クリア
      this.$store.commit("viewConfig/setSelectedPoint", "");
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 削除キャンセル */
    cancelDelete() {
      this.$log.debug("[Viewconfig] cancelDelete()");
      this.$store.commit("viewConfig/setDeleteFlg", 0);
    },
    /** 登録市町村有無 */
    isRegistTown() {
      if (this.towns) {
        for (let town of this.towns) {
          if (town.twnCd) {
            return true;
          }
        }
      }
      return false;
    },
    /** 個別設定初期化 */
    clickInitial() {
      this.$log.debug("[Viewconfig] clickInitial()");
      WebStorage.setCustomInfo({
        stage: false,
        dam: false,
        rain: false,
        cctv: false,
        scam: false,
        wtrQual: false,
        coast: false,
        snow: false,
        swin: false,
        fldfr: false,
        damdsch: false,
        fldctl: false,
        stageZmLvl: this.$store.state.app.config.mapConfig.zoomTmStg,
        damZmLvl: this.$store.state.app.config.mapConfig.zoomTmDam,
        rainZmLvl: this.$store.state.app.config.mapConfig.zoomTmRn,
        cctvZmLvl: this.$store.state.app.config.mapConfig.zoomTmCctv,
        scamZmLvl: this.$store.state.app.config.mapConfig.zoomTmScam,
        wtrQualZmLvl: this.$store.state.app.config.mapConfig.zoomTmQwtr,
        coastZmLvl: this.$store.state.app.config.mapConfig.zoomTmCoast,
        snowZmLvl: this.$store.state.app.config.mapConfig.zoomTmSnw,
        swinZmLvl: this.$store.state.app.config.mapConfig.zoomTmSwstg,
        baseObsOnly: false,
      });
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 現在位置取得・移動 */
    moveCurrentLocation() {
      if (!this.$store.state.map.currentLocationFlag) {
        // アクセスログ出力
        PageLog.log({
          page_log: "gps",
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
      this.$store.dispatch("map/moveCurrentLocation", "pc");
    },
    /** 現在位置登録 */
    registCurrentLocation() {
      this.$log.debug("[Viewconfig] registCurrentLocation()");
      PageLog.log({
        page_log: "gps",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("map/registCurrentLocation");
    },
    /** 登録キャンセル */
    registCancel() {
      this.$log.debug("[Viewconfig] registCancel()");

      // ステータスをクリア
      this.$store.commit("map/setEditLocationMode", 0);
      this.$store.commit("map/setEditTmMode", 0);
      this.$store.commit("map/setEditFlag", 0);

      // 地点登録状況に9:キャンセルを設定
      this.$store.commit("Telemeter/setRegistPointState", 9);
    },
    /** アイコン選択 */
    iconSelect() {
      this.$log.debug("[Viewconfig] iconSelect()");
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          point = WebStorage.getPoint5Info();
          break;
      }
      let iconImg =
        this.icons[this.iconIdx] + "_" + this.colors[this.colorIdx].name;
      if (this.iconIdx === 0) {
        iconImg += ".svg";
      } else {
        iconImg += ".png";
      }
      point.iconImg = iconImg;
      point.iconSize = this.sizeIdx;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          point = WebStorage.setPoint1Info(point);
          break;
        case 1:
          point = WebStorage.setPoint2Info(point);
          break;
        case 2:
          point = WebStorage.setPoint3Info(point);
          break;
        case 3:
          point = WebStorage.setPoint4Info(point);
          break;
        case 4:
          point = WebStorage.setPoint5Info(point);
          break;
      }
      this.$store.commit("viewConfig/setIconEditFlg", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** アイコンキャンセル */
    iconCancel() {
      this.$log.debug("[Viewconfig] iconCancel()");
      this.$store.commit("viewConfig/setIconEditFlg", 0);
    },
    /** アイコンURL */
    getIconUrl(idx) {
      let url = this.iconUrl + this.icons[idx] + "_navy";
      if (idx === 0) {
        url += ".svg";
      } else {
        url += ".png";
      }
      return url;
    },
    /** 地点登録メッセージのクリア */
    clearMsg() {
      this.$store.commit("Telemeter/setRegistPointMsg", "");
    },
  },
  watch: {
    /**
     * タブ選択値変更時
     */
    selectedIndex() {
      this.$log.debug("[Viewconfig] watch(selectedIndex)");
      let setQuery = Object.assign({}, this.$route.query);
      if (this.tabIndex === 0) {
        setQuery.type = "point";
        this.$store.commit("app/setContent", "VcPoint");
      } else if (this.tabIndex === 1) {
        setQuery.type = "default";
        this.$store.commit("app/setContent", "VcDefault");
      }
      // urlを書き換える
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /** 登録地点選択座標変更時 */
    editLocation() {
      this.$log.debug("[Viewconfig] watch(editLocation)");
      this.$store.commit("map/setEditLocationMode", 2);
    },
    /** 周辺観測所変更時 */
    editTm() {
      this.$log.debug("[Viewconfig] watch(editTm)");
      this.$store.commit("map/setEditTmMode", 2);
    },
    /** 地点登録 選択テレメータ情報変更時 */
    tmSelectedPointData() {
      this.$log.debug("[Viewconfig] watch(tmSelectedPointData)");
      // 観測所選択時
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) getPoint1Info"
          );
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) getPoint2Info"
          );
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) getPoint3Info"
          );
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) getPoint4Info"
          );
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) getPoint5Info"
          );
          point = WebStorage.getPoint5Info();
          break;
      }

      if (this.tmSelectedPointData.cctvCd) {
        this.$log.debug("[Viewconfig] watch(tmSelectedPointData) cctv");
        // CCTVの場合
        let cctvInfo = {
          ofcCd: this.tmSelectedPointData.ofcCd,
          cctvCd: this.tmSelectedPointData.cctvCd,
          cctvNm: this.tmSelectedPointData.cctvNm,
          riverName: this.tmSelectedPointData.riverName,
          lat: this.tmSelectedPointData.lat,
          lon: this.tmSelectedPointData.lon,
          twnCd: this.tmSelectedPointData.twnCd,
          distance: this.tmSelectedPointData.distance,
          notice: true,
        };
        point.tmDatas.cctvPoint.push(cctvInfo);
      } else {
        this.$log.debug("[Viewconfig] watch(tmSelectedPointData) tm");
        // テレメータの場合
        let tmInfo = "";
        if (
          this.tmSelectedPointData.itmkndCd === 1 ||
          this.tmSelectedPointData.itmkndCd === 4
        ) {
          tmInfo = {
            ofcCd: this.tmSelectedPointData.ofcCd,
            itmkndCd: this.tmSelectedPointData.itmkndCd,
            obsCd: this.tmSelectedPointData.obsCd,
            name: this.tmSelectedPointData.obsNm,
            riverName: this.tmSelectedPointData.rvrNm,
            lat: this.tmSelectedPointData.lat,
            lon: this.tmSelectedPointData.lon,
            twnCd: this.tmSelectedPointData.twnCd,
            distance: this.tmSelectedPointData.distance,
            notice: true,
          };
        } else {
          tmInfo = {
            ofcCd: this.tmSelectedPointData.ofcCd,
            itmkndCd: this.tmSelectedPointData.itmkndCd,
            obsCd: this.tmSelectedPointData.obsCd,
            name: this.tmSelectedPointData.obsNm,
            riverName: this.tmSelectedPointData.rvrNm,
            lat: this.tmSelectedPointData.lat,
            lon: this.tmSelectedPointData.lon,
            twnCd: this.tmSelectedPointData.twnCd,
            distance: this.tmSelectedPointData.distance,
            notice: false,
          };
        }
        point.tmDatas.tmPoint.push(tmInfo);

        // 通知情報の変更をDBに反映
        this.$store.dispatch("Telemeter/changeNotice", {
          pointNo: this.$store.state.viewConfig.selectedPoint,
          token: this.$store.state.app.token,
          selectedPoint: point,
        });
      }

      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint1Info"
          );
          WebStorage.setPoint1Info(point);
          break;
        case 1:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint2Info"
          );
          WebStorage.setPoint2Info(point);
          break;
        case 2:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint3Info"
          );
          WebStorage.setPoint3Info(point);
          break;
        case 3:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint4Info"
          );
          WebStorage.setPoint4Info(point);
          break;
        case 4:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint5Info"
          );
          WebStorage.setPoint5Info(point);
          break;
      }

      // モードを更新
      this.$store.commit("map/setEditTmMode", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 地点登録 選択危機管理型水位計情報 */
    swSelectedPointData() {
      this.$log.debug("[Viewconfig] watch(swSelectedPointData)");
      // 観測所選択時
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointData) getPoint1Info"
          );
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointData) getPoint2Info"
          );
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointData) getPoint3Info"
          );
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointData) getPoint4Info"
          );
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointData) getPoint5Info"
          );
          point = WebStorage.getPoint5Info();
          break;
      }
      let swInfo = {
        swobsCd: this.swSelectedPointData.swobsCd,
        swobsNm: this.swSelectedPointData.swobsNm,
        swrvrCd: this.swSelectedPointData.swrvrCd,
        swrvrNm: this.swSelectedPointData.swrvrNm,
        lat: this.swSelectedPointData.lat,
        lon: this.swSelectedPointData.lon,
        twnCd: this.swSelectedPointData.twnCd,
        distance: this.swSelectedPointData.distance,
        notice: true,
      };
      point.tmDatas.swPoint.push(swInfo);

      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint1Info"
          );
          WebStorage.setPoint1Info(point);
          break;
        case 1:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint2Info"
          );
          WebStorage.setPoint2Info(point);
          break;
        case 2:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint3Info"
          );
          WebStorage.setPoint3Info(point);
          break;
        case 3:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint4Info"
          );
          WebStorage.setPoint4Info(point);
          break;
        case 4:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint5Info"
          );
          WebStorage.setPoint5Info(point);
          break;
      }

      // 通知情報の変更をDBに反映
      this.$store.dispatch("Telemeter/changeNotice", {
        pointNo: this.$store.state.viewConfig.selectedPoint,
        token: this.$store.state.app.token,
        selectedPoint: point,
      });

      // モードを更新
      this.$store.commit("map/setEditTmMode", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 地点登録 選択簡易カメラ情報 */
    swSelectedPointScamData() {
      this.$log.debug("[Viewconfig] watch(swSelectedPointScamData)");
      // 観測所選択時
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) getPoint1Info"
          );
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) getPoint2Info"
          );
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) getPoint3Info"
          );
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) getPoint4Info"
          );
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) getPoint5Info"
          );
          point = WebStorage.getPoint5Info();
          break;
      }
      let scamInfo = {
        scamId: this.swSelectedPointScamData.scamId,
        sysId: this.swSelectedPointScamData.sysId,
        sysCamId: this.swSelectedPointScamData.sysCamId,
        name: this.swSelectedPointScamData.name,
        rvrCd: this.swSelectedPointScamData.rvrCd,
        rvrNm: this.swSelectedPointScamData.rvrNm,
        lat: this.swSelectedPointScamData.lat,
        lon: this.swSelectedPointScamData.lon,
        twnCd: this.swSelectedPointScamData.twnCd,
        distance: this.swSelectedPointScamData.distance,
        notice: true,
      };
      point.tmDatas.scamPoint.push(scamInfo);

      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) setPoint1Info"
          );
          WebStorage.setPoint1Info(point);
          break;
        case 1:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) setPoint2Info"
          );
          WebStorage.setPoint2Info(point);
          break;
        case 2:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) setPoint3Info"
          );
          WebStorage.setPoint3Info(point);
          break;
        case 3:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) setPoint4Info"
          );
          WebStorage.setPoint4Info(point);
          break;
        case 4:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointScamData) setPoint5Info"
          );
          WebStorage.setPoint5Info(point);
          break;
      }

      // モードを更新
      this.$store.commit("map/setEditTmMode", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 地点登録 選択危機カメラ情報 */
    swSelectedPointCctvData() {
      this.$log.debug("[Viewconfig] watch(swSelectedPointCctvData)");
      // 観測所選択時
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointCctvData) getPoint1Info"
          );
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointCctvData) getPoint2Info"
          );
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointCctvData) getPoint3Info"
          );
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointCctvData) getPoint4Info"
          );
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.$log.debug(
            "[Viewconfig] watch(swSelectedPointCctvData) getPoint5Info"
          );
          point = WebStorage.getPoint5Info();
          break;
      }
      let swcctvInfo = {
        swcctvCd: this.swSelectedPointCctvData.swcctvCd,
        swcctvNm: this.swSelectedPointCctvData.swcctvNm,
        swrvrCd: this.swSelectedPointCctvData.swrvrCd,
        swrvrNm: this.swSelectedPointCctvData.swrvrNm,
        lat: this.swSelectedPointCctvData.lat,
        lon: this.swSelectedPointCctvData.lon,
        twnCd: this.swSelectedPointCctvData.twnCd,
        distance: this.swSelectedPointCctvData.distance,
        notice: true,
      };
      point.tmDatas.swcctvPoint.push(swcctvInfo);

      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint1Info"
          );
          WebStorage.setPoint1Info(point);
          break;
        case 1:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint2Info"
          );
          WebStorage.setPoint2Info(point);
          break;
        case 2:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint3Info"
          );
          WebStorage.setPoint3Info(point);
          break;
        case 3:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint4Info"
          );
          WebStorage.setPoint4Info(point);
          break;
        case 4:
          this.$log.debug(
            "[Viewconfig] watch(tmSelectedPointData) setPoint5Info"
          );
          WebStorage.setPoint5Info(point);
          break;
      }

      // モードを更新
      this.$store.commit("map/setEditTmMode", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 登録地編集モード */
    editLocationMode() {
      this.$log.debug("[RegistPointDlg] watch(editLocationMode)");
      if (this.editLocationMode === 2) {
        let centerTwn = mapUtil.getNearTown(
          this.$store.state.map.editLocation.latlng,
          this.$store.state.map.latLngListByPref,
          this.$store.state.map.prefs
        );

        this.twnCd = centerTwn.townCd;
        this.centerTwn = centerTwn;

        let latlonList = geodesic.getBounds(
          this.$store.state.map.editLocation.latlng,
          this.$store.state.app.config.registConfig.townDistance
        );
        this.$store.dispatch("viewConfig/getTwns", {
          minlat: latlonList.minCoord[0],
          minlon: latlonList.minCoord[1],
          maxlat: latlonList.maxCoord[0],
          maxlon: latlonList.maxCoord[1],
        });
      } else if (this.editLocationMode === 0) {
        if (this.continuation === 1) {
          // 地点登録後にリスク判定を続行
          this.continuation = 2;
          // 確認ダイアログを表示
          this.$store.commit("viewConfig/setRiskFlg", 1);
        }
      }
    },
    /** 市町村リスト */
    towns() {
      this.$log.debug("[Viewconfig] watch(towns)");
      // 現在位置登録時は、市町村コードを設定
      if (this.registCurrentLocationFlag) {
        let centerTwn = mapUtil.getNearTown(
          this.$store.state.map.editLocation.latlng,
          this.$store.state.map.latLngListByPref,
          this.$store.state.map.prefs
        );
        this.twnCd = centerTwn.townCd;
        this.centerTwn = centerTwn;
      }
      // 選択した地点の市町村が、市町村のラジオに存在しない場合は追加する
      let isTwn = false;
      for (let town of this.towns) {
        if (town.twnCd === this.centerTwn.townCd) {
          isTwn = true;
        }
      }
      this.townsAdd = [];
      if (!isTwn) {
        this.townsAdd.push({
          twnCd: this.centerTwn.townCd,
          prefNm: this.centerTwn.prefNm,
          twnNm: this.centerTwn.townNm,
        });
      }
    },
    /** アイコン変更フラグ */
    iconEditFlg() {
      // webストレージから地点アイコンの設定を取得
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          point = WebStorage.getPoint5Info();
          break;
      }
      let iconImg = point.iconImg;
      if (iconImg) {
        iconImg = iconImg.replace(".svg", "");
        iconImg = iconImg.replace(".jpg", "");
        for (let ic = 0; ic < this.colors.length; ic++) {
          if (iconImg.indexOf(this.colors[ic].name) !== -1) {
            this.colorIdx = ic;
            break;
          }
        }
        for (let ii = 0; ii < this.icons.length; ii++) {
          if (iconImg.indexOf(this.icons[ii]) !== -1) {
            this.iconIdx = ii;
            break;
          }
        }
        this.sizeIdx = point.iconSize;
      } else {
        this.colorIdx = 6;
        this.iconIdx = 0;
        this.sizeIdx = 1;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";
@import "./../../../scss/color.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: 60%;
    top: 84px;
  }
  .large {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 50%;
    bottom: 4px;
  }
  .large {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
  .small {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 160px;
    bottom: 4px;
  }
}

#vc-dialog {
  right: 4px;
  .vc-tab {
    display: flex;
    flex-direction: row;
    margin: 0;
    height: 45px;
    .vc-tab-btn {
      margin: 0;
      width: 100px;
    }
  }
}

.vc-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
}

.vc-contents {
  height: calc(100% - 84px);
}

.vc-dialog-content {
  position: absolute;
  background-color: rgba(lightgray, 0.8);
  z-index: 3190;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  bottom: 0px;
  right: 0px;

  .vc-dialog-card {
    height: 90%;
    display: flex;
    flex-direction: column;

    .vc-dialog-header {
      background-color: $color-header-back;
      color: $color-header-text;
      line-height: 40px;
      height: 40px;
      width: 100%;
    }
    .vc-dialog-box {
      // flex: 1;
      height: calc(100% - 80px);
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      overflow-y: auto;
      .vc-dialog-box-confirm {
        font-size: 1rem;
      }

      .vc-radio-box {
        flex: 1;
        overflow-y: auto;
      }
    }

    .vc-dialog-box-btn {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
    }

    .vc-dialog-box-color {
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      overflow-y: auto;
      .vc-box-color {
        font-size: 1rem;
        margin: 0;
        padding: 0;

        .vc-icon-btn {
          margin: 0;
          padding: 0;
        }
        .vc-icon-btn-border {
          margin: 0;
          padding: 0;
          border: solid 2px black;
        }
      }
    }
    .vc-dialog-box-size {
      height: 55px;
      display: flex;
      flex-direction: row;
      overflow-y: auto;
      .vc-box-size {
        display: flex;
        align-items: flex-end;
        font-size: 1rem;
        margin: 0;
        padding: 0;

        .vc-icon-btn {
          margin: 0;
          padding: 0;
          cursor: pointer;
        }
        .vc-icon-btn-border {
          margin: 0;
          padding: 0;
          border: solid 2px black;
        }
      }
    }
    .vc-dialog-box-icon {
      height: 55px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      overflow-y: auto;
      .vc-box-icon {
        font-size: 1rem;
        margin: 0;
        padding: 0;

        .vc-icon-btn {
          margin: 0;
          padding: 2px 2px 2px 2px;
          cursor: pointer;
        }
        .vc-icon-btn-border {
          margin: 0;
          padding: 0;
          background-color: $color-btn-on !important;
          border-color: $color-btn-on !important;
          cursor: pointer;
        }
      }
    }

    .vc-dialog-box-progress {
      display: flex;
      flex-direction: column;
      height: 300px;
      .vc-td-item-loading {
        display: flex;
        justify-content: flex-end;
        width: calc(100% - 20px);
      }
      .vc-td-item-cancel {
        display: flex;
        justify-content: flex-end;
        width: 100%;
      }
    }
    .vc-dialog-footer {
      height: 40px;
    }
    .get-location-error-message {
      color: $color-error-message;
    }
  }
}
.vc-btn-item {
  justify-content: center;
  font-size: 0.55rem;

  .vc-btn-image {
    height: 20px;
  }
}
.vc-dialog-box-confirm {
  font-size: 1rem;
}
</style>
